import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import styled from 'styled-components';

export const Address = () => (
  <Wrppaer>
    <TextWrapper>
      <p>주식회사 엑스바디</p>
      <p>Copyright 2023. exbody all rights reserved.</p>
      <p>대표: 김미숙</p>
      <p>이메일: exbodypr@exbody.com</p>
    </TextWrapper>

    <TextWrapper className="bold">
      <p>고객센터 02-6925-6080</p>
      <p>운영시간 평일 09:00 AM ~ 05:00 PM</p>
      <p>대표번호 02-6925-6080</p>
      <p>FAX 02-6925-6077</p>
    </TextWrapper>

    <TextWrapper>
      <p>서울시 금천구 가산디지털 1로 151, 이노플렉스 BD, 9F</p>
      <p>사업자 등록번호 119-86-49785</p>
      <p>통신판매업 신고번호: 제2012-서울금천-0894호</p>
    </TextWrapper>
  </Wrppaer>
);

const Wrppaer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: ${color.navyLight};
  color: ${color.white2};
`;

const TextWrapper = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;

  &.bold p {
    ${font.caption2_medium};
  }

  & p {
    ${font.caption2_light};
  }
`;
